// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2B9kn","content":"RecentSearches_content__lsai7"};